// import {itemDefault, detailDefault} from '../util/defaults'

export default {
  data: function () {
    return {
      type: 'Reservation',
      types: 'Reservation',
      apiRecordCommand: 'diningReservation',
      loadedListResources: false,
      searchFilter: this.getSavedListSearchFilter(),
      searchFilterName: 'reservationListFilter',
      apiPagination: true,
      loadedSearchFilters: false,
      selectedNoShowId: null
    }
  }
}
